import { AnyAction, ReducersMapObject } from "@reduxjs/toolkit";

import AuthReducer from "features/auth/store/slice";
import AppReducer from "features/app/store/slice";
import PrivateChatReducer from "features/private-chat/store/slice";
import SystemConfigReducer from "features/system-config/store/slice";
import UserManagementReducer from "features/user-management/store/slice";
import DocumentManagementReducer from "features/document-management/store/slice";
import PermissionManagementReducer from "features/permission-management/store/slice";
import HistoryManagementReducer from "features/history-chat/store/slice";
import CrawlingURLReducer from "features/crawling/store/slice";
import { RootState } from "types/reducer";
import SecurityMonitoringReducer from "features/security-monitoring/store/slice";

const reducer: ReducersMapObject<RootState, AnyAction> = {
  app: AppReducer,
  auth: AuthReducer,
  private_chat: PrivateChatReducer,
  system_config: SystemConfigReducer,
  user_management: UserManagementReducer,
  document_management: DocumentManagementReducer,
  permission_management: PermissionManagementReducer,
  history_management: HistoryManagementReducer,
  crawling_url: CrawlingURLReducer,
  security_monitoring: SecurityMonitoringReducer,
};

export default reducer;
